module.exports = __webpack_public_path__ + "img/star.a8216f6e.png";